/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberStatus } from './MemberStatus';
import {
    MemberStatusFromJSON,
    MemberStatusFromJSONTyped,
    MemberStatusToJSON,
} from './MemberStatus';

/**
 * Member Data as Member
 * @export
 * @interface MemberDataAsMember
 */
export interface MemberDataAsMember {
    /**
     * Member ID
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberId: string;
    /**
     * Account ID
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountId: string;
    /**
     * Account Username
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountUsername: string;
    /**
     * Account Email
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountEmail: string;
    /**
     * Account Status
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountStatus: string;
    /**
     * Account Role
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountRole: string;
    /**
     * Account Given Name
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountGivenName: string;
    /**
     * Account Family Name
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountFamilyName: string;
    /**
     * Account Phone Number
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountPhoneNumber: string;
    /**
     * Account Last Seen Date
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountLastSeenDate: string;
    /**
     * Account Created Date
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountCreatedDate: string;
    /**
     * Account Updated Date
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberAccountUpdatedDate: string;
    /**
     * Account Hide Phone From Members
     * @type {boolean}
     * @memberof MemberDataAsMember
     */
    memberAccountHidePhoneFromMembers: boolean;
    /**
     * Account Hide Email From Members
     * @type {boolean}
     * @memberof MemberDataAsMember
     */
    memberAccountHideEmailFromMembers: boolean;
    /**
     * Member Given Name
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberGivenName: string;
    /**
     * Member Family Name
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberFamilyName: string;
    /**
     * 
     * @type {MemberStatus}
     * @memberof MemberDataAsMember
     */
    memberStatus: MemberStatus;
    /**
     * Member Sponsored By Member ID
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberSponsoredByMemberId: string | null;
    /**
     * Member Descendant Of
     * @type {string}
     * @memberof MemberDataAsMember
     */
    memberDescendantOf: string;
    /**
     * Member Date Joined
     * @type {Date}
     * @memberof MemberDataAsMember
     */
    memberDateJoined: Date;
    /**
     * Member Created Date
     * @type {Date}
     * @memberof MemberDataAsMember
     */
    memberCreatedDate: Date;
    /**
     * Member Updated Date
     * @type {Date}
     * @memberof MemberDataAsMember
     */
    memberUpdatedDate: Date;
}



/**
 * Check if a given object implements the MemberDataAsMember interface.
 */
export function instanceOfMemberDataAsMember(value: object): value is MemberDataAsMember {
    if (!('memberId' in value) || value['memberId'] === undefined) return false;
    if (!('memberAccountId' in value) || value['memberAccountId'] === undefined) return false;
    if (!('memberAccountUsername' in value) || value['memberAccountUsername'] === undefined) return false;
    if (!('memberAccountEmail' in value) || value['memberAccountEmail'] === undefined) return false;
    if (!('memberAccountStatus' in value) || value['memberAccountStatus'] === undefined) return false;
    if (!('memberAccountRole' in value) || value['memberAccountRole'] === undefined) return false;
    if (!('memberAccountGivenName' in value) || value['memberAccountGivenName'] === undefined) return false;
    if (!('memberAccountFamilyName' in value) || value['memberAccountFamilyName'] === undefined) return false;
    if (!('memberAccountPhoneNumber' in value) || value['memberAccountPhoneNumber'] === undefined) return false;
    if (!('memberAccountLastSeenDate' in value) || value['memberAccountLastSeenDate'] === undefined) return false;
    if (!('memberAccountCreatedDate' in value) || value['memberAccountCreatedDate'] === undefined) return false;
    if (!('memberAccountUpdatedDate' in value) || value['memberAccountUpdatedDate'] === undefined) return false;
    if (!('memberAccountHidePhoneFromMembers' in value) || value['memberAccountHidePhoneFromMembers'] === undefined) return false;
    if (!('memberAccountHideEmailFromMembers' in value) || value['memberAccountHideEmailFromMembers'] === undefined) return false;
    if (!('memberGivenName' in value) || value['memberGivenName'] === undefined) return false;
    if (!('memberFamilyName' in value) || value['memberFamilyName'] === undefined) return false;
    if (!('memberStatus' in value) || value['memberStatus'] === undefined) return false;
    if (!('memberSponsoredByMemberId' in value) || value['memberSponsoredByMemberId'] === undefined) return false;
    if (!('memberDescendantOf' in value) || value['memberDescendantOf'] === undefined) return false;
    if (!('memberDateJoined' in value) || value['memberDateJoined'] === undefined) return false;
    if (!('memberCreatedDate' in value) || value['memberCreatedDate'] === undefined) return false;
    if (!('memberUpdatedDate' in value) || value['memberUpdatedDate'] === undefined) return false;
    return true;
}

export function MemberDataAsMemberFromJSON(json: any): MemberDataAsMember {
    return MemberDataAsMemberFromJSONTyped(json, false);
}

export function MemberDataAsMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberDataAsMember {
    if (json == null) {
        return json;
    }
    return {
        
        'memberId': json['member_id'],
        'memberAccountId': json['member_account_id'],
        'memberAccountUsername': json['member_account_username'],
        'memberAccountEmail': json['member_account_email'],
        'memberAccountStatus': json['member_account_status'],
        'memberAccountRole': json['member_account_role'],
        'memberAccountGivenName': json['member_account_given_name'],
        'memberAccountFamilyName': json['member_account_family_name'],
        'memberAccountPhoneNumber': json['member_account_phone_number'],
        'memberAccountLastSeenDate': json['member_account_last_seen_date'],
        'memberAccountCreatedDate': json['member_account_created_date'],
        'memberAccountUpdatedDate': json['member_account_updated_date'],
        'memberAccountHidePhoneFromMembers': json['member_account_hide_phone_from_members'],
        'memberAccountHideEmailFromMembers': json['member_account_hide_email_from_members'],
        'memberGivenName': json['member_given_name'],
        'memberFamilyName': json['member_family_name'],
        'memberStatus': MemberStatusFromJSON(json['member_status']),
        'memberSponsoredByMemberId': json['member_sponsored_by_member_id'],
        'memberDescendantOf': json['member_descendant_of'],
        'memberDateJoined': (new Date(json['member_date_joined'])),
        'memberCreatedDate': (new Date(json['member_created_date'])),
        'memberUpdatedDate': (new Date(json['member_updated_date'])),
    };
}

export function MemberDataAsMemberToJSON(value?: MemberDataAsMember | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'member_id': value['memberId'],
        'member_account_id': value['memberAccountId'],
        'member_account_username': value['memberAccountUsername'],
        'member_account_email': value['memberAccountEmail'],
        'member_account_status': value['memberAccountStatus'],
        'member_account_role': value['memberAccountRole'],
        'member_account_given_name': value['memberAccountGivenName'],
        'member_account_family_name': value['memberAccountFamilyName'],
        'member_account_phone_number': value['memberAccountPhoneNumber'],
        'member_account_last_seen_date': value['memberAccountLastSeenDate'],
        'member_account_created_date': value['memberAccountCreatedDate'],
        'member_account_updated_date': value['memberAccountUpdatedDate'],
        'member_account_hide_phone_from_members': value['memberAccountHidePhoneFromMembers'],
        'member_account_hide_email_from_members': value['memberAccountHideEmailFromMembers'],
        'member_given_name': value['memberGivenName'],
        'member_family_name': value['memberFamilyName'],
        'member_status': MemberStatusToJSON(value['memberStatus']),
        'member_sponsored_by_member_id': value['memberSponsoredByMemberId'],
        'member_descendant_of': value['memberDescendantOf'],
        'member_date_joined': ((value['memberDateJoined']).toISOString()),
        'member_created_date': ((value['memberCreatedDate']).toISOString()),
        'member_updated_date': ((value['memberUpdatedDate']).toISOString()),
    };
}

